<script lang="ts">
  import { Dropdown } from 'bootstrap';
  import { onMount, type Snippet } from 'svelte';

  interface Props {
    toggleBtnClass?: string;
    toggleBtnTitle: string | Snippet;
    children: Snippet;
    disabled?: boolean;
  }

  let { toggleBtnClass = 'btn-primary dropdown-toggle', toggleBtnTitle, children, disabled }: Props = $props();

  let expanded = $state(false);

  let toggle: HTMLButtonElement;
  let dropdownEl: HTMLDivElement;
  let bsDropdown: Dropdown;

  onMount(() => {
    bsDropdown = new Dropdown(toggle);

    // bootstrap js takes care of state management of the visibility of the dropdown, but we need to react to it to
    // update the aria-expanded state
    dropdownEl.addEventListener('hide.bs.dropdown', () => {
      expanded = false;
    });

    dropdownEl.addEventListener('shown.bs.dropdown', () => {
      expanded = true;
    });

    return () => {
      bsDropdown.dispose();
    };
  });
</script>

<div class="dropdown" bind:this={dropdownEl}>
  <button
    class="btn {toggleBtnClass}"
    data-bs-toggle="dropdown"
    type="button"
    aria-expanded={expanded}
    {disabled}
    bind:this={toggle}
  >
    {#if typeof toggleBtnTitle === 'string'}
      {toggleBtnTitle}
    {:else}
      {@render toggleBtnTitle()}
    {/if}
  </button>
  <ul class="dropdown-menu">
    {@render children()}
  </ul>
</div>
